const apiEndpoint = "/api";

export { apiEndpoint };
